module.exports = __webpack_public_path__ + "img/fankui_wu.f6a9b0cf.png";